module.exports = __webpack_public_path__ + "static/media/workspace.d403c47e.jpg";